var _dec, _dec2, _dec3, _class, _class2, _descriptor, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, html } from '@sick-davinci/ce-decorators';
import { style } from './OptionGroup.style';
/**
 * `davinci-option-group` can be used to group `davinci-option` elements inside a `davinci-dropdown`
 * 
 * @slot { davinci-option } list of `davinci-option` elements 
 */

export let OptionGroup = (_dec = Component({
  tag: `davinci-option-group`,
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = (_temp = class OptionGroup extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "label", _descriptor, this);
  }

  render() {
    return html`<div class="label">${this.label}</div>
                <div><slot></slot></div>`;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
//# sourceMappingURL=OptionGroup.js.map